import $ from "jquery";
import React, { useEffect, useState } from 'react';
import {
  createBrowserRouter,
  RouterProvider,
} from 'react-router-dom';
import './App.css';
import Error from './pages/Error';
import Games from './pages/Games';
import Home from './pages/Home';
import Info from './pages/Info';
import InfoYearFiles from './pages/InfoYear';
import MatchAnimals from './pages/Match_animals';
import MatchShapes from './pages/Match_shapes';
import MatchWords from './pages/Match_words';
import MyClass from './pages/MyClass';
import { config } from './util/constants';
// import XmasMS from './pages/XmasMS';
// import XmasZS from './pages/XmasZS';
import MatchPenguins from './pages/Match_penguins';
// import Maths from './pages/Maths';
// import CatMaths from './pages/Maths_cats';
import Cap from './pages/Cap';
import CapCycle from './pages/CapCycle';
import CustomPage from './pages/CustomPage';
import CustomPageEditor from './pages/CustomPageEditor';
import MatchChosen from './pages/Match_chosen';
import Maths from './pages/Maths';
import MathsCycle from './pages/MathsCycle';
import MathsMisc from './pages/MathsMisc';
import Misc from './pages/Misc';
import Pexeso from './pages/Pexeso';
import Quiz from './pages/Quiz';
import Slovak from './pages/Slovak';
import SlovakCycle from './pages/SlovakCycle';
import SlovakMisc from './pages/SlovakMisc';
import Teeth from './pages/TrueFalse_teeth';
import CapMisc from "./pages/CapMisc";
import Cas from "./pages/Cas";
import CasCycle from "./pages/CasCycle";
import CasMisc from "./pages/CasMisc";
import InfoYear from "./pages/InfoYear";
import InfoMisc from "./pages/InfoMisc";
import Main from "./pages/Main";
import UserAccessEvents from './pages/UserAccessEvents';
import UserAccessNotifications from './pages/UserAccessNotifications';
import UserAccessUserDetail from './pages/UserAccessUserDetail';
import UserAccessUserEditor from './pages/UserAccessUserEditor';
import UserAccessUsers from './pages/UserAccessUsers';

export interface UserContext {
  user: User | null
  loginUser: (username: string, password: string) => Promise<boolean>
  logoutUser: () => void
}

export interface User {
  username: string
  fullName: string
}

export interface FileInfo {
  fileId: string
  fileName: string
  fileSize: number
  fileType: string
}

export enum FolderType {
  public = "publicFolder",
  private = "privateFolder"
}

export interface PupilInfo {
  id: number
  name: string
  badges?: { [key: string]: number }
  points?: { [key: string]: number }
  picked?: boolean
  booksRented?: string[]
}

export interface BookInfo {
  isbn: string
  title: string
  count: number
  author?: string
  annotation?: string
  image?: string
}

export type CustomPageListItem = {
  id?: string;
  pageId?: string;
  _id?: string;
  title?: string;
};

export const UserContext = React.createContext<UserContext>({} as UserContext);

const baseUrl = config.API_URL;

function App() {
  const [user, setUser] = useState<User | null>(null);

  useEffect(() => {
    window.addEventListener("dragover", handleDragOver, false);
    window.addEventListener("drop", handleDrop, false);

    document.addEventListener('pointerdown', handleDragStart);
    document.addEventListener('pointermove', handleDrag);
    document.addEventListener('pointerup', handleDragStop);
    
    return (() => {
      window.addEventListener("dragover", handleDragOver, false);
      window.addEventListener("drop", handleDrop, false);

      document.removeEventListener('pointerdown', handleDragStart);
      document.removeEventListener('pointermove', handleDrag);
      document.removeEventListener('pointerup', handleDragStop);
    });
  }, []);

  let draggedEl: HTMLElement | null;

  const handleDragStart = (e: any) => {
    if (!e.target || !e.target.matches || !e.target.matches('.draggable')) {
      return;
    }

    const el = $(e.target as HTMLElement);
    const rect = e.target.getBoundingClientRect();
    $("#root").append(el.detach());
    el.css({left: rect.x, top: rect.y, width: rect.width, height: rect.height, position: 'absolute'});
    el.data('originx', rect.x);
    el.data('originy', rect.y);
    el.data('dsx', e.clientX);
    el.data('dsy', e.clientY);
    
    draggedEl = el.get(0) as HTMLElement;
  };

  const handleDrag = (e: any) => {
    if (draggedEl == null) {
      return;
    }
    
    const de = $(draggedEl);
    
    const dx = e.clientX - parseInt(de.data('dsx'), 10);
    const dy = e.clientY - parseInt(de.data('dsy'), 10);
    const newPosX = parseInt(de.data('originx'), 10) + dx;
    const newPosY = parseInt(de.data('originy'), 10) + dy;

    draggedEl.style.left = newPosX + 'px';
    draggedEl.style.top = newPosY + 'px';
  };

  const handleDragStop = (e: any) => {
    if (draggedEl == null) {
      return;
    }
    
    let dropX = e.clientX;
    let dropY = e.clientY;

    if (draggedEl != null) {
      draggedEl.style.visibility = 'hidden';
      draggedEl.dispatchEvent(new CustomEvent('custom-drop', {detail: {dropX, dropY}} as any));
    }
    draggedEl = null;
  };

  const handleDragOver = (e: Event) => {
    e.preventDefault();
  };
  const handleDrop = (e: Event) => {
    e.preventDefault();
  };

  const loginUser = (username: string, password: string) => {
    return fetch(baseUrl + '/authenticate', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      },
      credentials: 'include',
      body: 'username=' + encodeURIComponent(username) + '&password=' + encodeURIComponent(password)
    }).then((res: Response) => {
      if (res.ok) {
        res.json().then((user: User) => {
          setUser(user);
        });
        return true;
      }
      console.error("Failed to authenticate!");
      return false;
    }).catch((e: Error) => {
      console.error("Failed to authenticate!");
      return false;
    });
  }

  const logoutUser = () => {
    fetch(baseUrl + '/logout', {
      credentials: 'include'
    }).then((res: Response) => {
      if (res.ok) {
        setUser(null);
      }
    }).catch((e: Error) => {
      // ignore
    });
  }

  const checkUserIsLoggedIn = () => {
    fetch(baseUrl + '/isAuthenticated', {
      credentials: 'include'
    }).then((res: Response) => {
      if (res.ok) {
        res.json().then((user: User) => {
          setUser(user);
        });
      }
    }).catch((e: Error) => {
      // ignore
    });
  }

  useEffect(() => {
    checkUserIsLoggedIn();
  }, []);

  return <>
    <UserContext.Provider value={{ user, loginUser, logoutUser }}>
      <RouterProvider router={router} />
    </UserContext.Provider>
  </>
}

const router = createBrowserRouter([
  {
    path: "/",
    element: <Home />,
    errorElement: <Error />
  },
  {
    path: "/main",
    element: <Main />,
    errorElement: <Error />
  },
  {
    path: "/games",
    element: <Games />,
    errorElement: <Error />
  },
  {
    path: "/games/:game",
    element: <Games />,
    errorElement: <Error />
  },
  {
    path: "/games/pexeso",
    element: <Pexeso />,
    errorElement: <Error />
  },
  {
    path: "/games/pexeso/:game",
    element: <Pexeso />,
    errorElement: <Error />
  },
  {
    path: "/games/quiz",
    element: <Quiz />,
    errorElement: <Error />
  },
  {
    path: "/maths",
    element: <Maths />,
    errorElement: <Error />
  },
  {
    path: "/maths/cycle/:cycleId",
    element: <MathsCycle />,
    errorElement: <Error />
  },
  {
    path: "/maths/misc",
    element: <MathsMisc />,
    errorElement: <Error />
  },
  {
    path: "/maths/penguins",
    element: <MatchPenguins />,
    errorElement: <Error />
  },
  {
    path: "/maths/shapes",
    element: <MatchShapes />,
    errorElement: <Error />
  },
  {
    path: "/slovak",
    element: <Slovak />,
    errorElement: <Error />
  },
  {
    path: "/slovak/cycle/:cycleId",
    element: <SlovakCycle />,
    errorElement: <Error />
  },
  {
    path: "/slovak/misc",
    element: <SlovakMisc />,
    errorElement: <Error />
  },
  {
    path: "/slovak/words",
    element: <MatchWords />,
    errorElement: <Error />
  },
  {
    path: "/slovak/chosen",
    element: <MatchChosen />,
    errorElement: <Error />
  },
  {
    path: "/cap",
    element: <Cap />,
    errorElement: <Error />
  },
  {
    path: "/cap/cycle/:cycleId",
    element: <CapCycle />,
    errorElement: <Error />
  },
  {
    path: "/cap/misc",
    element: <CapMisc />,
    errorElement: <Error />
  },
  {
    path: "/cap/animals",
    element: <MatchAnimals />,
    errorElement: <Error />
  },
  {
    path: "/cap/truefalse_teeth",
    element: <Teeth />,
    errorElement: <Error />
  },
  {
    path: "/cas",
    element: <Cas />,
    errorElement: <Error />
  },
  {
    path: "/cas/cycle/:cycleId",
    element: <CasCycle />,
    errorElement: <Error />
  },
  {
    path: "/cas/misc",
    element: <CasMisc />,
    errorElement: <Error />
  },
  {
    path: "/info",
    element: <Info />,
    errorElement: <Error />
  },
  {
    path: "/info/year/:year",
    element: <InfoYear />,
    errorElement: <Error />
  },
  {
    path: "/info/misc",
    element: <InfoMisc />,
    errorElement: <Error />
  },
  {
    path: "/misc",
    element: <Misc />,
    errorElement: <Error />
  },
  {
    path: "/custom/edit",
    element: <CustomPageEditor />,
    errorElement: <Error />
  },
  {
    path: "/custom/edit/:pageId",
    element: <CustomPageEditor />,
    errorElement: <Error />
  },
  {
    path: "/custom/:path/:pageId",
    element: <CustomPage />,
    errorElement: <Error />
  },
  {
    path: "/myclass",
    element: <MyClass />,
    errorElement: <Error />
  },
  {
    path: "/userAccessEvents",
    element: <UserAccessEvents />,
    errorElement: <Error />
  },
  {
    path: "/userAccessUsers",
    element: <UserAccessUsers />,
    errorElement: <Error />
  },
  {
    path: "/userAccessUsers/new",
    element: <UserAccessUserEditor />,
    errorElement: <Error />
  },
  {
    path: "/userAccessUsers/:userId/edit",
    element: <UserAccessUserEditor />,
    errorElement: <Error />
  },
  {
    path: "/userAccessUsers/:userId",
    element: <UserAccessUserDetail />,
    errorElement: <Error />
  },
  {
    path: "/userAccessNotifications",
    element: <UserAccessNotifications />,
    errorElement: <Error />
  },
    // {
  //   path: "/library",
  //   element: <Library />,
  //   errorElement: <Error />
  // },
  // {
  //   path: "/xmas-ms",
  //   element: <XmasMS />,
  //   errorElement: <Error />
  // },
  // {
  //   path: "/xmas-zs",
  //   element: <XmasZS />,
  //   errorElement: <Error />
  // },
]);

export default App;
